if (!customElements.get('product-card-carousel')) {
class ProductCardCarousel extends HTMLElement {
  constructor() {
    super();
    this.intervalId = null;
    this.activeIndex = 0;
    this.onEnter = this.onEnter.bind(this);
    this.onLeave = this.onLeave.bind(this);
  }

  connectedCallback() {
    this.images = Array.from(this.querySelectorAll('img'));
    if (this.images.length < 2) return;

    const card = this.closest('.card-wrapper') || this;
    this.listenTarget = card;
    this.listenTarget.addEventListener('mouseenter', this.onEnter);
    this.listenTarget.addEventListener('mouseleave', this.onLeave);
    this.listenTarget.addEventListener('focusin', this.onEnter);
    this.listenTarget.addEventListener('focusout', this.onLeave);
  }

  disconnectedCallback() {
    this.stop();
    if (this.listenTarget) {
      this.listenTarget.removeEventListener('mouseenter', this.onEnter);
      this.listenTarget.removeEventListener('mouseleave', this.onLeave);
      this.listenTarget.removeEventListener('focusin', this.onEnter);
      this.listenTarget.removeEventListener('focusout', this.onLeave);
    }
  }

  onEnter() {
    if (this.intervalId) return;
    this.intervalId = setInterval(() => {
      this.activeIndex = (this.activeIndex + 1) % this.images.length;
      this.setActive(this.activeIndex);
    }, 700);
  }

  onLeave() {
    this.stop();
    this.activeIndex = 0;
    this.setActive(0);
  }

  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  setActive(index) {
    this.images.forEach((img, i) => img.classList.toggle('is-active', i === index));
  }
}

customElements.define('product-card-carousel', ProductCardCarousel);
}
